module.exports = __webpack_public_path__ + "static/media/deliverd.1dfcbc20.svg";